<app-slide-in-right-modal
  [modalTitle]="'Create Minor Account'"
  iconImageSrc="assets/images/svgs/document--outline.svg"
  [returnPath]="returnPathUrl"
  [slideOpen]="true"
>
  <div class="page__container flex flex-col pb-8">
    <form
      class="flex flex-col gap-5"
      [formGroup]="minorForm"
      (ngSubmit)="submit()"
    >

      <div class="form-row flex flex-col gap-5">

        <!-- NIN -->
        <div>
          <app-input-label
            labelFor="national-identity-number"
            [isRequired]="true"
            labelClass="label--bottom-margin"
          >
            National Identity Number
          </app-input-label>

          <app-input
            placeholder="Enter Minor's NIN"
            inputClass="input--padding"
            formControlName="nin"
          ></app-input>
        </div>

        <!-- First Name -->
        <div>
          <app-input-label 
            [isRequired]="true"
            labelClass="label--bottom-margin"
            >
            First Name
          </app-input-label>

          <app-input
            formControlName="first_name"
            placeholder="Enter Minor's First Name..."
          />
        </div>

        <!-- Last Name -->
        <div>
          <app-input-label 
            [isRequired]="true"
            labelClass="label--bottom-margin"
            >
            Last Name
          </app-input-label>

          <app-input
            formControlName="last_name"
            placeholder="Enter Minor's Last Name..."
          />
        </div>

        <!-- Email -->
        <div>
          <app-input-label
            labelFor="email"
            labelClass="label--bottom-margin"
            >Email</app-input-label
          >
          <div class="relative rounded-lg shadow-sm">
            <app-input
              placeholder="Enter Minor's Email Adress..."
              inputClass="input--padding"
              formControlName="email"
            ></app-input>

            <div
              *ngIf="isCheckingEmail"
              class="absolute right-2 top-1/2 -translate-y-1/2"
            >
              <span class="text-gray-400 text-sm">Checking...</span>
            </div>
          </div>

          <div
            *ngIf="minorForm.get('email')?.hasError('emailExists')"
            class="text-red-500 text-sm mt-1"
          >
            Email already exists
          </div>
          <div
            *ngIf="minorForm.get('email')?.hasError('serverError')"
            class="text-red-500 text-sm mt-1"
          >
            Unable to verify email
          </div>
        </div>

        <!-- Date of Birth -->
        <div>
          <app-input-label
            labelClass="label--bottom-margin"
            [isRequired]="true"
          >
            Date of Birth
          </app-input-label>

          <input
            formControlName="dob"
            class="block w-full rounded-lg border-0 pl-2 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-mango"
            type="date"
            [min]="minDate"
            [max]="maxDate"
          />
        </div>
      </div>

      <button
        type="submit"
        mango-button
        class="w-fit shrink-0 items-center justify-end"
        [disabled]="
          isLoading ||
          minorForm.invalid ||
          minorForm.pending || 
          isCheckingEmail
        "
      >
        @if (isLoading) {
          <span spin></span>
        } @else {
          <span>Submit</span>
        }
      </button>
    </form>
  </div>
</app-slide-in-right-modal>